import { gql } from '@apollo/client';
import classNames from 'classnames';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import type {
  TemplateSidebarItem_PostFragment,
  TemplateSidebarItem_TemplateFragment,
} from '../graphql/generated/graphqlTypes';
import templateIcon from '../icons/prefilled/template.svg';
import templatePath from '../utils/url/templatesPath';
import styles from './TemplateSidebarItem.module.scss';

const TEMPLATE_SIDEBAR_ITEM_TEMPLATE_FRAGMENT = gql`
  fragment TemplateSidebarItem_template on Template {
    id
    title
  }
`;

const TEMPLATE_SIDEBAR_ITEM_POST_FRAGMENT = gql`
  fragment TemplateSidebarItem_post on Post {
    id
    title
  }
`;

interface TemplateSidebarItemProps {
  template:
    | TemplateSidebarItem_TemplateFragment
    | TemplateSidebarItem_PostFragment;
  active: boolean;
  onClick?: () => void;
}

const TemplateSidebarItem = ({
  template,
  active,
  onClick,
}: TemplateSidebarItemProps) => {
  const content = (
    <>
      <div className={styles.templateIcon}>
        <SVGIcon>{templateIcon}</SVGIcon>
      </div>
      {template.title}
    </>
  );

  if (onClick) {
    return (
      <Button
        onClick={onClick}
        className={classNames(styles.template, { [styles.active]: active })}
      >
        {content}
      </Button>
    );
  }

  return (
    <Link
      to={templatePath(template)}
      className={classNames(styles.template, { [styles.active]: active })}
    >
      {content}
    </Link>
  );
};

TemplateSidebarItem.fragments = {
  template: TEMPLATE_SIDEBAR_ITEM_TEMPLATE_FRAGMENT,
  post: TEMPLATE_SIDEBAR_ITEM_POST_FRAGMENT,
};

export default TemplateSidebarItem;
